import { makeStyles, alpha } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    paper: {
        width: 480,
        maxWidth: '480px',
        borderRadius: 4,
        boxShadow: '0 24px 64px rgba(0,0,40,.18)',
        overflow: 'hidden',
        padding: 0,
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        padding: '24px 28px 0',
    },
    headerLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: 14,
    },
    title: {
        fontSize: 16,
        fontWeight: 700,
        color: theme.palette.text.primary,
        letterSpacing: '-0.01em',
        lineHeight: 1.2,
    },
    subtitle: {
        marginTop: 2,
        fontSize: 13,
        color: theme.palette.text.secondary,
    },
    closeButton: {
        color: theme.palette.text.secondary,
    },
    body: {
        padding: '20px 28px',
    },
    infoBox: {
        backgroundColor: alpha(theme.palette.error.main, 0.06),
        border: `1px solid ${alpha(theme.palette.error.main, 0.24)}`,
        borderRadius: 10,
        padding: '16px 18px',
        marginBottom: 20,
        color: theme.palette.text.primary,
        fontSize: 13,
        lineHeight: 1.65,
    },
    infoLabel: {
        fontSize: 13,
        fontWeight: 700,
        color: theme.palette.text.primary,
        marginBottom: 8,
    },
    bulletList: {
        margin: 0,
        paddingLeft: 18,
        '& li': {
            marginBottom: 5,
        },
    },
    checkboxRow: {
        marginBottom: 24,
    },
    checkboxLabelWrap: {
        display: 'flex',
        gap: 12,
        alignItems: 'flex-start',
        cursor: 'pointer',
    },
    checkboxInput: {
        marginTop: 3,
        accentColor: theme.palette.error.main,
        width: 15,
        height: 15,
        flexShrink: 0,
        cursor: 'pointer',
    },
    checkboxLabel: {
        fontSize: 13,
        color: theme.palette.text.primary,
        lineHeight: 1.6,
    },
        errorRow:{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 24,
    },
    errorText: {
        color: theme.palette.error.main,
        fontSize: 13,
        marginBottom: 12,
    },
    footer: {
        display: 'flex',
        gap: 10,
    },
    keepBtn: {
        flexShrink: 0,
        padding: '12px 24px',
        borderRadius: 4,
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        border: `1px solid ${theme.palette.divider}`,
        fontSize: 13,
        fontWeight: 600,
        letterSpacing: '.04em',
        textTransform: 'uppercase',
        '&:hover': {
            backgroundColor: theme.palette.grey[100],
        },
    },
    cancelPlanBtn: {
        flex: 1,
        padding: '12px 24px',
        borderRadius: 4,
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText,
        fontSize: 13,
        fontWeight: 600,
        letterSpacing: '.04em',
        textTransform: 'uppercase',
        '&:hover': {
            backgroundColor: theme.palette.error.main,
        },
        '&.Mui-disabled': {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
            opacity: 0.4,
        },
    },
    processing: {
        padding: '60px 28px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 16,
    },
    processingText: {
        fontSize: 14,
        color: theme.palette.text.secondary,
    },
}));
